import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import DropdownItem from '@/components/DropdownItem';
import ToolsMenu from '@/components/tools/ToolsMenu';
import { cloneCohortQuery, deleteCohortQuery, showRenameQuery } from '../actions';

const CohortQueryTools = ({
  category,
  code,
  queryUUID,
  duplicate,
  rename,
  remove,
  allowRemove,
}) => (
  <ToolsMenu listItem icon="caret down" pointing={null}>
    <DropdownItem icon="edit" textId="actions.rename" onClick={() => rename(code, category, queryUUID)} />
    <DropdownItem icon="clone" textId="actions.duplicate" onClick={() => duplicate(code, category, queryUUID)} />
    {allowRemove && (
      <DropdownItem icon="trash alternate" textId="actions.delete" onClick={() => remove(code, category, queryUUID)} />
    )}
  </ToolsMenu>
);

export const mapStateToProps = ({
  cohorts: { cohorts },
}, { category, code }) => {
  const cohort = findResult(cohorts, category, code);
  return ({
    allowRemove: cohort.queries.length > 1,
  });
};

const mapDispatchToProps = {
  rename: showRenameQuery,
  remove: deleteCohortQuery,
  duplicate: cloneCohortQuery,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortQueryTools);
